export default "__VITE_ASSET__DLPLjxMD__"